import { Stack } from "@mui/material";
import CardFilters from "../filters/CardFilters";
import CardTable from "../tables/CardTable";
import { useHasScope } from "../../../../../config/globalConfig";
import { AMEXSOF_VIEW_CARDS } from "../../../utils/FinanceScope";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";

function Cards() {

    const hasScope = useHasScope;

    if (!hasScope(AMEXSOF_VIEW_CARDS)) return <NotAuthorizedDialog />

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <CardFilters/>
                <CardTable/>
            </Stack>
    );
}

export default Cards;